<form class="pt-4" [formGroup]="form">
  <ng-container>
    <div class="p-float-label mb-5">
      <input class="w-full" pInputText [formControl]="paramsForm.controls.url" />
      <label>{{ 'data-source.file.label.source-url' | translate }}</label>
    </div>

    <h5>{{ 'data-source.common.label.format' | translate }}</h5>

    <div class="flex gap-3 mb-5 align-items-center">
      <div class="flex-1">
        <p-dropdown styleClass="w-full" [options]="format" [formControl]="paramsForm.controls.fileFormat"></p-dropdown>
      </div>
    </div>

    @if (paramsForm.controls.fileFormat.value === 'csv' && paramsForm.controls.csvFileFormatParams) {
      @let csvFileFormatParamsForm = paramsForm.controls.csvFileFormatParams;
      <div class="mb-5">
        <label class="cursor-pointer">
          <p-checkbox
            class="mr-2"
            [formControl]="csvFileFormatParamsForm.controls.includeHeader"
            [binary]="true"
          ></p-checkbox>
          {{ 'data-source.common.checkbox.first-row-header' | translate }}
        </label>
      </div>

      <div class="mb-5">
        <label class="cursor-pointer">
          <p-checkbox
            class="mr-2"
            [formControl]="csvFileFormatParamsForm.controls.convert01ToBoolean"
            [binary]="true"
          ></p-checkbox>
          {{ 'data-source.common.checkbox.convert-boolean' | translate }}
        </label>
      </div>

      <div class="flex gap-3 mb-5">
        <div class="flex align-items-center" *ngFor="let separator of separators">
          <p-radioButton
            [label]="separator.labelTranslate | translate"
            [value]="separator.id"
            [formControl]="csvFileFormatParamsForm.controls.separatorType"
          ></p-radioButton>
        </div>

        <div class="p-float-label">
          <input class="w-full" pInputText [formControl]="csvFileFormatParamsForm.controls.customSeparator" />
          <label>{{ 'data-source.common.separator.custom' | translate }}</label>
        </div>
      </div>
    }
  </ng-container>
  <div class="mb-5">
    <selfai-platform-data-source-visibility
      [control]="form.controls.visibility"
    ></selfai-platform-data-source-visibility>
  </div>
  <div class="mb-5">
    <selfai-platform-data-source-unique-name [control]="form.controls.name"></selfai-platform-data-source-unique-name>
  </div>

  <selfai-platform-data-sources-additionals
    [properties]="dataSource?.params?.properties"
    [additionalList]="additionalList"
    (changeEvent)="onPropertiesValue($event)"
  ></selfai-platform-data-sources-additionals>
</form>
